import React from 'react';
import { motion } from 'framer-motion';
interface SalesSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
  id?: string;
}
export function SalesSection({
  title,
  children,
  className = '',
  dark = false,
  id
}: SalesSectionProps) {
  return <section id={id} className={`py-20 px-4 sm:px-6 lg:px-8 ${dark ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'} ${className}`} data-id="element-138">
      <div className="mx-auto max-w-3xl" data-id="element-139">
        {title && <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className={`mb-10 text-3xl font-bold leading-tight sm:text-4xl md:text-5xl ${dark ? 'text-white' : 'text-gray-900'}`} data-id="element-140">
            {title}
          </motion.h2>}

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className={`prose prose-lg ${dark ? 'prose-invert' : 'prose-gray'} max-w-none`} data-id="element-141">
          {children}
        </motion.div>
      </div>
    </section>;
}